<template>
  <nav class="nav">
    <ul class="nav-list" v-if="!!!userInfo">
      <li class="nav-list-item">
        <router-link
          class="nav-list-item-link"
          to="/home"
          exact
          active-class="active"
          >{{ $t('nav.home') }}</router-link
        >
      </li>
      <li class="nav-list-item">
        <router-link
          class="nav-list-item-link"
          to="/about-us"
          exact
          active-class="active"
          >{{ $t('nav.about_us') }}</router-link
        >
      </li>
      <li class="nav-list-item">
        <router-link
          class="nav-list-item-link"
          to="/products"
          exact
          active-class="active"
          :class="{ active: isRelatedToProd }"
          >{{ $t('nav.products') }}</router-link
        >
      </li>
      <li class="nav-list-item">
        <router-link
          class="nav-list-item-link"
          to="/login"
          exact
          active-class="active"
          >{{ $t('nav.customer_center') }}</router-link
        >
      </li>
      <li class="nav-list-item">
        <router-link
          class="nav-list-item-link"
          to="/download-center"
          exact
          active-class="active"
          >{{ $t('nav.download_center') }}</router-link
        >
      </li>
      <li class="nav-list-item">
        <router-link
          class="nav-list-item-link"
          to="/contact-us"
          exact
          active-class="active"
          >{{ $t('nav.contact_us') }}</router-link
        >
      </li>
    </ul>

    <ul class="nav-list" v-if="!!userInfo">
      <li class="nav-list-item">
        <router-link
          class="nav-list-item-link"
          to="/vehicle"
          active-class="active"
          >{{ $t('nav.vehicle') }}</router-link
        >
      </li>
      <li class="nav-list-item">
        <router-link
          class="nav-list-item-link"
          to="/part"
          active-class="active"
          :class="{ active: isRelatedToPart }"
          >{{ $t('nav.part') }}</router-link
        >
      </li>
      <li class="nav-list-item">
        <router-link
          class="nav-list-item-link"
          to="/shoppingcart?tab=1"
          active-class="active"
          >{{ $t('nav.shopping_cart') }}</router-link
        >
      </li>
      <li class="nav-list-item">
        <router-link
          class="nav-list-item-link"
          to="/order?tab=1"
          exact
          active-class="active"
          :class="{ active: isRelatedToOrder }"
          >{{ $t('nav.my_order') }}</router-link
        >
      </li>
    </ul>
  </nav>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { mapState } from 'vuex';

const partPath = [
  '/part-result',
  '/part',
  '/part-detail',
  '/diagram',
  '/catalogue',
  '/spare-part'
];

const productPath = ['/products', '/products-inquiry'];

const orderPath = [
  '/order',
  '/vehicle-order-detail',
  '/vehicle-logistics-info',
  '/part-logistics-info',
  '/vehicle-logistics-detail',
  '/part-logistics-detail',
  '/part-order-detail'
];

export default defineComponent({
  name: 'Nav',
  props: {
    msg: String
  },
  computed: {
    ...mapState(['userInfo'])
  },
  data() {
    return {
      isRelatedToPart: false,
      isRelatedToProd: false,
      isRelatedToOrder: false
    };
  },
  watch: {
    '$route.path': {
      handler(newVal) {
        // scroll to top
        // if (newVal.toUpperCase().indexOf('/home'.toUpperCase()) >= 0) {
        //   document.body.scrollTop = document.documentElement.scrollTop = 100;
        // } else {
        //   window.scrollTo(0, 0);
        // }
        window.scrollTo(0, 0);

        if (
          orderPath.some(
            p => newVal.toUpperCase().indexOf(p.toUpperCase()) >= 0
          )
        ) {
          this.isRelatedToOrder = true;
          this.isRelatedToPart = false;
          this.isRelatedToProd = false;
          return;
        } else {
          this.isRelatedToOrder = false;
        }

        if (
          productPath.some(
            p => newVal.toUpperCase().indexOf(p.toUpperCase()) >= 0
          )
        ) {
          this.isRelatedToProd = true;
          this.isRelatedToOrder = false;
          this.isRelatedToPart = false;
          return;
        } else {
          this.isRelatedToProd = false;
        }

        if (
          partPath.some(p => newVal.toUpperCase().indexOf(p.toUpperCase()) >= 0)
        ) {
          this.isRelatedToPart = true;
          this.isRelatedToOrder = false;
          this.isRelatedToProd = false;
          return;
        } else {
          this.isRelatedToPart = false;
        }
      },
      immediate: true
    }
  }
});
</script>

<style scoped lang="scss">
.nav-list {
  display: flex;

  &-item {
    padding: 0 24px;
  }

  &-item-link {
    font-size: 13px;
    line-height: 1;
    color: #666;
    letter-spacing: 0.11px;
    display: inline-block;
    font-weight: bold;
    padding: 30px 0 32px;
    text-decoration: none;
    border-bottom: 2px solid transparent;
    transition: all 350ms ease;
  }

  &-item-link:hover,
  &-item-link.active {
    color: #039;
    border-color: #039;
  }
}
</style>
